import {
  ChakraBox,
  ChakraLink,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';
import {
  CATEGORY_PATIENT_CARE,
  HG_LAB_RESULTS,
} from '~/lib/constants/task.constants';
import { parseDescriptionForUrlMarkup } from '~/lib/util/task.util';

const { label: labelStyle, h6 } = EquipUITheme.typography;

interface TitleAndCaptionProps {
  description: string;
  name: string;
  categoryName?: string;
  subcategoryName?: string;
}

const TitleAndCaption = ({
  description,
  name,
  categoryName,
  subcategoryName,
}: TitleAndCaptionProps) => {
  const shouldShowTaskDescriptionForLabResults =
    categoryName === CATEGORY_PATIENT_CARE &&
    subcategoryName.toLowerCase() === HG_LAB_RESULTS;

  return (
    <ChakraBox>
      <ChakraText
        {...h6}
        color="neutral.primary"
        fontWeight="400"
        paddingBottom="4px"
      >
        {name}
      </ChakraText>
      <ChakraText
        {...labelStyle}
        color="neutral.secondary"
        isTruncated
        lineHeight="16.8px"
      >
        {description
          ? parseDescriptionForUrlMarkup(
              description,
              ChakraLink,
              shouldShowTaskDescriptionForLabResults,
            )
          : ''}
      </ChakraText>
    </ChakraBox>
  );
};

export default TitleAndCaption;
